import { render, staticRenderFns } from "./Case-Header-Sidrosan.vue?vue&type=template&id=03b746e1"
import script from "./Case-Header-Sidrosan.vue?vue&type=script&lang=js"
export * from "./Case-Header-Sidrosan.vue?vue&type=script&lang=js"
import style0 from "./Case-Header-Sidrosan.vue?vue&type=style&index=0&id=03b746e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports